import { render, staticRenderFns } from "./ContactRelationshipList.vue?vue&type=template&id=23fa93ad&scoped=true"
import script from "./ContactRelationshipList.vue?vue&type=script&lang=js"
export * from "./ContactRelationshipList.vue?vue&type=script&lang=js"
import style0 from "./ContactRelationshipList.vue?vue&type=style&index=0&id=23fa93ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa93ad",
  null
  
)

export default component.exports